import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
interface Props {
  open: boolean;
  close: () => void;
  handleSave: (title: string) => void;
}
export const SaveBrushModal = (props: Props) => {
  const [title, setTitle] = useState<string>("");

  return (
    <Dialog
      open={props.open}
      scroll={"paper"}
      aria-labelledby="form-dialog-title"
      style={{ zIndex: 1000000000 }}
    >
      <DialogTitle id="form-dialog-title">Save Brush</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Save your current brush settings to use again!
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="Title"
          label="Brush Title"
          type="text"
          fullWidth
          onChange={(e) => {
            setTitle(e.currentTarget.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.close} color="primary">
          Cancel
        </Button>
        <Button
          disabled={title === ""}
          onClick={() => {
            props.handleSave(title);
            props.close();
          }}
          color="primary"
        >
          Save Brush!
        </Button>
      </DialogActions>
    </Dialog>
  );
};
